import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type RecoveryState = {
  email: string;
  setEmail: (email: string) => void;
  clear: () => void;
};

export const useRecoveryStore = create(
  persist<RecoveryState>(
    (set) => ({
      email: '',
      setEmail: (email) => set({ email }),
      clear: () => set({ email: '' }),
    }),
    {
      name: 'recovery-storage', // unique name
    },
  ),
);
